import { addMonths, format, parseISO } from 'date-fns'

import type { TSimulacaoGrupoMensalPrice } from '@/features/simulador/brasil/domain/schemas/simulacao-price.schema'
import type { TGrupoParcelasToUTC } from '@/utils/grupo-parcelas.utils'

export class MensaisMapper {
  static transformPrice(mensais: TSimulacaoGrupoMensalPrice | null | undefined): TGrupoParcelasToUTC[] {
    if (!mensais?.parcelas?.length) return []
    return mensais.parcelas.flatMap(({ dataInicio, ...mensal }) =>
      dataInicio
        ? [
            {
              percentualParticipacao: mensais.percentual,
              parcelas: Array.from({ length: mensal.quantidade }).map((_, i) => ({
                valor: mensal.valor,
                data: format(addMonths(parseISO(dataInicio), i), 'yyyy-MM-dd'),
              })),
            },
          ]
        : [],
    )
  }
}
